module.exports = __webpack_public_path__ + "img/spark.35737425.svg";